import { makeVar } from '@apollo/client';
export const currentCalendarPrice = makeVar({});
export const currentSummaryPrice = makeVar({});
export const currentSrpPrice = makeVar({});
